import { OnEvent } from "common/onEvent";
export async function wait(video) {
    const onEvent = new OnEvent({
        eventName: "canplay",
        selector: video,
        hasFiredBefore: () => {
            return video.readyState >= 3;
        },
    });
    await onEvent.waitOnce();
}
//# sourceMappingURL=canplaythrough.js.map